import React from 'react';

const NotFound = () => {
     return (
          <div>
               <h2 className="text-red-700">Not Found 404!</h2>
          </div>
     );
};

export default NotFound;